import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";
import { useAuth } from "@/contexts/AuthContext";
import { Button } from "@/components/ui/button";
import { PlayCircle, X } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { useState } from "react";

export function ActiveTestsBanner() {
  const { user } = useAuth();
  const navigate = useNavigate();
  const [dismissed, setDismissed] = useState(false);

  const { data: inProgressTests } = useQuery({
    queryKey: ['active-tests-banner', user?.id],
    queryFn: async () => {
      if (!user?.id) return [];
      
      const { data, error } = await supabase
        .from('test_responses')
        .select(`
          id,
          test_id,
          tests (
            id,
            title
          )
        `)
        .eq('candidate_id', user.id)
        .eq('status', 'in_progress')
        .order('started_at', { ascending: false })
        .limit(1);

      if (error) throw error;
      return data || [];
    },
    enabled: !!user?.id,
  });

  if (!inProgressTests || inProgressTests.length === 0 || dismissed) {
    return null;
  }

  const test = inProgressTests[0];

  return (
    <div className="bg-primary/10 border-b border-primary/20">
      <div className="container max-w-7xl mx-auto px-6 py-3">
        <div className="flex items-center justify-between gap-4">
          <div className="flex items-center gap-3">
            <PlayCircle className="h-5 w-5 text-primary" />
            <div>
              <p className="text-sm font-medium text-foreground">
                You have an active test in progress
              </p>
              <p className="text-xs text-muted-foreground">
                {test.tests?.title}
              </p>
            </div>
          </div>
          
          <div className="flex items-center gap-2">
            <Button
              size="sm"
              onClick={() => navigate(`/test/${test.test_id}/take?responseId=${test.id}`)}
            >
              Resume Test
            </Button>
            <Button
              size="sm"
              variant="ghost"
              onClick={() => setDismissed(true)}
            >
              <X className="h-4 w-4" />
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
}
